<template v-if="showReviews">
  <adivare-cancellation-review-form/>
  <lazy-component>
    <adivare-cancellation-review-list/>
  </lazy-component>
</template>

<script>
import AdivareCancellationReviewList from './cancellation-review-list';
import AdivareCancellationReviewForm from "./cancellation-review-form";

export default {
  name: "adivare-cancellation-review-main",
  components: {
    AdivareCancellationReviewForm,
    AdivareCancellationReviewList,
  },
  computed: {
    showReviews() {
      return false === this.$store.getters.generic && null !== this.$store.getters.getActiveCancellation;
    },
  },
}
</script>
